import { PagedMessageResponse } from "app/api/types/PagedMessageResponse";
import { IItemOrcamento } from "app/types/IItemOrcamento";
import { Permissao } from "app/types/Permissao";
import { obterPermissao } from "app/use-cases/obterPermissao";
import { Dict } from "app/utils/Dict";
import React, { ReactNode, useEffect, useState } from "react";
import { doisPassos } from "../breadcrumb2/Breadcrumb2.stories";
import { EntitesDadosEstoque } from "../Estoque/Estoque";
import { PedidoClienteContainer } from "../Estoque/sub-consultas/pedidos-cliente/PedidoClienteContainer";
import { PedidosFornecedorContainer } from "../Estoque/sub-consultas/pedidos-fornecedor/PedidosFornecedorContainer";
import { ReservaProdutoContainer } from "../itens-orcamento/reserva-produto/ReservaProdutoContainer";
import { removerComponenteReact, renderizarComponentReact } from "../renderizarOuRemoverComponentReact";
import { MenuSubConsultaProduto } from "./MenuSubConsultaProduto";
import { EncomendaProdutoContainer } from "../Estoque/sub-consultas/encomenda/EncomendaProdutoContainer";
import { NotasFiscaisPendentesContainer } from "../Estoque/sub-consultas/notas-fiscais-pendentes/NotasFiscaisPendentesContainer";
import { RmaContainer } from "../Estoque/sub-consultas/rma/RmaContainer";

export type MenuSubConsulta = {
    item: IItemOrcamento
    estoqueSelecionado: EntitesDadosEstoque;
    //dadosEstoque: PagedMessageResponse<EntitesDadosEstoque>
    onVoltar: () => void;
    onRemover: () => boolean
    passos: Dict<string, () => void>;
    foraOrcamento: boolean;
}

export type MenuSubConsultaProdutoContainerProps = {
    item: IItemOrcamento
    estoqueSelecionado: EntitesDadosEstoque;
    //dadosEstoque: PagedMessageResponse<EntitesDadosEstoque>
    onSelecionadoMenu: () => void;
    onVoltar: () => void;
    passos: Dict<string, () => void>;
    foraOrcamento: boolean;
}

export const MenuSubConsultaProdutoContainer = (props: MenuSubConsultaProdutoContainerProps) => {
    const [permissoes, setPermissoes] = useState<Permissao[]>([])
    const [parametrosCarregados, setParametrosCarregados] = useState(false)

    const atualizarPermissoes = async () => {
        setPermissoes([
            {
                Acao: "CONSULTAR_RESERVAS_PRODUTOS",
                Permitido: await obterPermissao({ funcionalidade: "ORCAMENTO_ITEM_VENDA", acao: "CONSULTAR_RESERVAS_PRODUTOS" })
            },
            {
                Acao: "CONSULTAR_PEDIDOS_FORNECEDORES_PRODUTO",
                Permitido: await obterPermissao({ funcionalidade: "ORCAMENTO_ITEM_VENDA", acao: "CONSULTAR_PEDIDOS_FORNECEDORES_PRODUTO" })
            },
            {
                Acao: "CONSULTAR_PEDIDOS_CLIENTES_PRODUTO",
                Permitido: await obterPermissao({ funcionalidade: "ORCAMENTO_ITEM_VENDA", acao: "CONSULTAR_PEDIDOS_CLIENTES_PRODUTO" })
            },
            {
                Acao: "CONSULTAR_ENCOMENDAS_PRODUTOS",
                Permitido: await obterPermissao({ funcionalidade: "ORCAMENTO_ITEM_VENDA", acao: "CONSULTAR_ENCOMENDAS_PRODUTOS" })
            },
            {
                Acao: "CONSULTAR_NAO_ENTREGUE_EXPEDICAO",
                Permitido: await obterPermissao({ funcionalidade: "ORCAMENTO_ITEM_VENDA", acao: "CONSULTAR_NAO_ENTREGUE_EXPEDICAO" })
            },
            {
                Acao: "CONSULTAR_NAO_ENTREGUE_FUTURA",
                Permitido: await obterPermissao({ funcionalidade: "ORCAMENTO_ITEM_VENDA", acao: "CONSULTAR_NAO_ENTREGUE_FUTURA" })
            },
        ])
        setParametrosCarregados(true)
    }

    const propsBae: MenuSubConsulta = {
        item: props.item,
        estoqueSelecionado: props.estoqueSelecionado,
        //dadosEstoque: props.dadosEstoque,
        onRemover: () => removerComponenteReact("conteudo-pagina"),
        onVoltar: () => props.onVoltar(),
        passos: props.passos,
        foraOrcamento: props.foraOrcamento
    }

    const onRenderizarSubConsultaReservas = () => {
        renderizarComponentReact(<ReservaProdutoContainer {...propsBae} />, "conteudo-pagina", true);
    }

    const onRenderizarSubConsultaPedidosFornecedores = () => {
        renderizarComponentReact(<PedidosFornecedorContainer {...propsBae} />, "conteudo-pagina", true);
    }

    const onRenderizarSubConsultaPedidosClientes = () => {
        renderizarComponentReact(<PedidoClienteContainer {...propsBae} />, "conteudo-pagina", true);
    }

    const onRenderizarSubConsultaEncomenda = () => {
        renderizarComponentReact(<EncomendaProdutoContainer {...propsBae} />, "conteudo-pagina", true);
    }

    const onRenderizarSubConsultaNaoEntregueExpedicao = () => {
        renderizarComponentReact(<NotasFiscaisPendentesContainer {...propsBae} tipoEntrega="E" />, "conteudo-pagina", true);
    }

    const onRenderizarSubConsultaNaoEntregueFutura = () => {
        renderizarComponentReact(<NotasFiscaisPendentesContainer {...propsBae} tipoEntrega="F" />, "conteudo-pagina", true);
    }

    const onRenderizarSubConsultaRma = () => {
        renderizarComponentReact(<RmaContainer {...propsBae} />, "conteudo-pagina", true);
    }

    useEffect(() => {
        atualizarPermissoes()
    }, [])

    return (
        <>
            {parametrosCarregados &&
                <MenuSubConsultaProduto
                    permitirVisualiarReservas={permissoes?.find((perimissao) => perimissao.Acao == "CONSULTAR_RESERVAS_PRODUTOS")?.Permitido}
                    permitirVisualiarPedidosFornecedores={permissoes?.find((perimissao) => perimissao.Acao == "CONSULTAR_PEDIDOS_FORNECEDORES_PRODUTO")?.Permitido}
                    permitirVisualiarPedidosClientes={permissoes?.find((perimissao) => perimissao.Acao == "CONSULTAR_PEDIDOS_CLIENTES_PRODUTO")?.Permitido}
                    permitirVisualiarEncomenda={permissoes?.find((perimissao) => perimissao.Acao == "CONSULTAR_ENCOMENDAS_PRODUTOS")?.Permitido}
                    permitirVisualiarNaoEntregueExpedicao={permissoes?.find((perimissao) => perimissao.Acao == "CONSULTAR_NAO_ENTREGUE_EXPEDICAO")?.Permitido}
                    permitirVisualiarNaoEntregueFutura={permissoes?.find((perimissao) => perimissao.Acao == "CONSULTAR_NAO_ENTREGUE_FUTURA")?.Permitido}
                    habilitarReservas={Number(!props.estoqueSelecionado?.QuantidadeReservado) > 0}
                    habilitarPedidosFornecedores={!props.estoqueSelecionado}
                    habilitaPedidosClientes={!props.estoqueSelecionado}
                    habilitarEncomenda={Number(!props.estoqueSelecionado?.Encomenda) > 0}
                    habilitaNaoEntregueExpedicao={!props.estoqueSelecionado}
                    habilitaNaoEntregueFutura={!props.estoqueSelecionado}
                    habilitarRma={props.estoqueSelecionado?.QuantidadeRMA > 0}
                    onRenderizarSubConsultaReservas={onRenderizarSubConsultaReservas}
                    onRenderizarSubConsultaPedidosFornecedores={onRenderizarSubConsultaPedidosFornecedores}
                    onRenderizarSubConsultaPedidosClientes={onRenderizarSubConsultaPedidosClientes}
                    onRenderizarSubConsultaEncomenda={onRenderizarSubConsultaEncomenda}
                    onRenderizarSubConsultaNaoEntregueExpedicao={onRenderizarSubConsultaNaoEntregueExpedicao}
                    onRenderizarSubConsultaNaoEntregueFutura={onRenderizarSubConsultaNaoEntregueFutura}
                    onRenderizarSubConsultaRma={onRenderizarSubConsultaRma}
                    onSelecionadoMenu={props.onSelecionadoMenu}

                />
            }
        </>
    )
}